import * as React from 'react';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardActions from '@mui/joy/CardActions';
import CircularProgress from '@mui/joy/CircularProgress';
import Typography from '@mui/joy/Typography';
import { Link } from 'react-router-dom';

interface CustomDashboardCardProps {
    title?: string;
    value?: any;
    color?: any;
    type?: string;
    icon?: any;
}

const CustomDashboardCard = (props: CustomDashboardCardProps) => {
    return (
        <Card variant="solid" color={props.color} invertedColors>
            <CardContent orientation="horizontal">
                <CircularProgress size="lg" determinate value={props.value}>
                    {props.icon}
                </CircularProgress>
                <CardContent>
                    <Typography level="title-lg"><strong>{props.title}</strong></Typography>
                    <Typography level="h2"> {props.value} </Typography>
                </CardContent>
            </CardContent>
        </Card>
    )
}

export default CustomDashboardCard